import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { MessageService, ToastMessage } from '../../services/message.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ToastContainerComponent {
  readonly toasts$: Observable<ToastMessage[]>;

  constructor(private messageService: MessageService) {
    this.toasts$ = this.messageService.toasts$;
  }

  dismiss(id: number): void {
    this.messageService.dismiss(id);
  }
}
